import { ref } from 'vue';
import vehicleService from '@/services/store/vehicle.service';
import { IVehicleEligibility } from '@/interfaces/entities/vehicle-eligibility.interface';

export default function useVehicleEligibility() {
  const vehicleEligibility = ref<IVehicleEligibility | null>(null);

  async function setVehicleEligibility(glassesId: number, productName?: string) {
    const vehicleEligibilityResponse = await vehicleService.getEligibility(glassesId, productName);
    vehicleEligibility.value = vehicleEligibilityResponse;
  }

  return { vehicleEligibility, setVehicleEligibility };
}
